module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/500k-active-b190138160d7dd8bc3b64d57ff48b3c9.png";